<template>
    <q-layout data-testid="report-manager" class="q-pa-lg">
      <q-card class="fit">
        <q-card-section class="q-py-xs">
          <div class="report-title">
            {{reportTitle || name}}
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <JtDynamicForm
              data-testid="form"
              ref="form"
              :inputs="form.inputs"
              :model="form.dadosForm"
              :relacionamentos="form.relacionamentos"
              :interface="form.nmInterface"
              @on-select-change="onSelectChangeHandler"
            />
          </div>
        </q-card-section>
      </q-card>
      <div class="row full-width q-col-gutter-lg justify-center q-py-md">
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="grey-7" @click="onClear">
                    {{ $gettext('CLEAN') }}
                </q-btn>
            </div>
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="info" @click="openDialogReport">
                {{ $gettext('GENERATE') }}
                </q-btn>
            </div>
        </div>
        <q-dialog v-model="visible" persistent>
      <q-card>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{$gettext('REPORT_SELECTION')}}</span>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <q-radio v-model="financialMapReportFormat" val="pdf" label="PDF" />
          <q-radio v-model="financialMapReportFormat" val="xls" label="Excel" />
        </q-card-section>
      <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn :label="$gettext('CANCEL')" color="grey-7" v-close-popup class="q-px-lg" />
          <q-btn :label="$gettext('GENERATE')" color="info" v-close-popup @click="onGenerateReportClick" class="q-px-lg" />
        </q-card-actions>
      </q-card>
    </q-dialog>
      <JtDocsViewer
        :src="fileSrc"
        :title="reportTitle || name"
        :pdf="reportFormat.pdf"
        :xls="reportFormat.xls"
        ref="reportModal"
      />
    </q-layout>
  </template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtDocsViewer } from 'jtech-webcomps/src/components/jtech-docs'
import { JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'FinancialMapReport',
  components: {
    JtDynamicForm,
    JtDocsViewer
  },
  props: {
    forms: { type: Array, required: true }
  }
})
class FinancialMapReport extends Vue {
  fileSrc = null
  reportTitle = 'Mapa de Faturamento'
  visible = false;
  financialMapReportFormat = 'pdf';
  dadosTelaFromRepository = []
  reportGenerationFormat = {
    online: true,
    scheduling: false
  }

  onClear () {
    const currentFlagValue = this.$refs.form._props.model.exportedOrders
    this.$refs.form.resetForm()
    this.$refs.form._props.model.exportedOrders = currentFlagValue
  }

  __getDisplayData () {
    return repository.resolve('financialMapReport.financialMapReport')
  }

  async beforeMount () {
    this.dadosTelaFromRepository = await this.__getDisplayData()
  }

  get form () {
    return this.dadosTelaFromRepository[0]
  }

  get reportFormat () {
    return {
      pdf: this.financialMapReportFormat === 'pdf',
      xls: this.financialMapReportFormat === 'xls'
    }
  }

  emitCloseToBus () {
    this.$emit('on-close', {})
  }

  openDialogReport () {
    this.visible = true
  }

  get computedDadosTelaFromRepository () {
    return Array.isArray(this.dadosTelaFromRepository) &&
      this.dadosTelaFromRepository.length
      ? this.dadosTelaFromRepository[0]
      : {}
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        this.financialMapReportFormat,
        '',
        'application/' + this.financialMapReportFormat
      )
      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        if (this.reportFormat.xls) {
          this.__downloadFile(this.fileSrc, this.reportTitle, '.xls')
          this.emitCloseToBus()
        } else {
          this.$refs.reportModal.show()
        }
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
    const link = document.createElement('a')
    link.style = 'display: none'
    link.download = `${fileName}${extension}`
    link.href = fileSrc
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  async onGenerateReportClick () {
    this.computedDadosTelaFromRepository.dadosForm = { ...this.computedDadosTelaFromRepository.dadosForm, relFormatoRelatorio: this.financialMapReportFormat === 'pdf' ? 1 : 3 }
    try {
      this.$emit('generate', {
        dadosForm: this.computedDadosTelaFromRepository.dadosForm,
        nmInterface: this.computedDadosTelaFromRepository.nmInterface
      })
      const resolveLogicResult = await this.$jt.repository.resolveLogic(
        this.computedDadosTelaFromRepository.nmInterface,
        this.computedDadosTelaFromRepository.dadosForm
      )

      await this.__whenGenerationFormatIsOnline(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }
}

export default FinancialMapReport
</script>

<style>
.report-title {
  font-weight: 500;
  font-size: 1.3em;
  margin-top: 5px;
  border-bottom: 1px solid #e0e0e0;
}
.btn-container {
  margin-top: 30px;
}
</style>
